"use client";
import { useThemeWithUndefined } from '@rescui/ui-contexts';
import { createTextCn } from './create-text-cn.js';

const useTextStyles = () => createTextCn(useThemeWithUndefined());

export { useTextStyles };
